import React, { useState } from 'react';
import { useTranslate } from 'react-redux-multilingual'
import { Dropdown} from "react-bootstrap";


const Preparation = (props) =>{
    const t = useTranslate();

    return (
        <Dropdown.Item eventKey="12" onClick={()=>props.handleClick('to_prepare')}>{t('btnPrepare')}</Dropdown.Item>
    )
};

export default Preparation;